
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-090511ec&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UserButtons.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UserButtons.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-090511ec!../../../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserButtons.vue"),
  /* scopeId */
  "data-v-090511ec",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/structure/ui/actions/UserButtons.vue
// module id = 1957
// module chunks = 1